import { render, staticRenderFns } from "./indexIndividualWeddingrings.vue?vue&type=template&id=17cc652c"
import script from "./indexIndividualWeddingrings.vue?vue&type=script&lang=ts"
export * from "./indexIndividualWeddingrings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconCircle: require('/codebuild/output/src3458403893/src/acredo-website/components/icon/iconCircle.vue').default,IconCircleFill: require('/codebuild/output/src3458403893/src/acredo-website/components/icon/iconCircleFill.vue').default,HtmlBrandButton: require('/codebuild/output/src3458403893/src/acredo-website/components/html/htmlBrandButton.vue').default})
